import Vue from 'vue';

export const store = Vue.observable({ dialogInformation: {}, isCustomDialog: false });

export const observableMutations = {
  setDialogInformation(value) {
    store.dialogInformation = value;
  },
};
